(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (!reduce) root.classList.add('bas-js');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* BASILISK REVIEW ROW SIZE FORCE */
    function basForceRatingInline() {
      document.querySelectorAll('.bas-rating-inline').forEach(function (row) {
        row.style.display = 'flex';
        row.style.alignItems = 'center';
        row.style.gap = '.82rem';
        row.style.margin = '.34rem 0 .74rem';
        row.style.lineHeight = '1';
        var stars = row.querySelector('.bas-rating-inline__stars');
        var text = row.querySelector('.bas-rating-inline__text');
        if (stars) {
          stars.style.color = '#ff5a47';
          stars.style.fontSize = (window.innerWidth <= 749 ? '1.46rem' : '1.6rem');
          stars.style.letterSpacing = '.1em';
        }
        if (text) {
          text.style.color = 'rgba(255,255,255,.98)';
          text.style.fontSize = (window.innerWidth <= 749 ? '1.12rem' : '1.22rem');
          text.style.fontWeight = '800';
          text.style.letterSpacing = '.01em';
        }
      });
    }
    basForceRatingInline();
    window.addEventListener('resize', basForceRatingInline, { passive: true });
    var targets = [];
    document.querySelectorAll('.bas').forEach(function (scope) {
      var sel = '.bas-eyebrow,.bas-h2,.bas-h3,.bas-p,.bas-frame,.bas-card,.bas-mode,' +
                '.bas-step,.bas-notice,.bas-fit,.bas-btn,.bas-spec,.bas-trustrow,.bas-bullets';
      scope.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-bas-reveal]')) return;
        el.setAttribute('data-bas-reveal', '');
        targets.push(el);
      });
    });

    document.querySelectorAll('.bas-grid').forEach(function (grid) {
      Array.prototype.slice.call(grid.children).forEach(function (child, i) {
        child.style.setProperty('--i', Math.min(i, 8));
      });
    });

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
      setTimeout(function () {
        targets.forEach(function (el) { el.classList.add('is-in'); });
      }, 3000);
    }

    var par = [].slice.call(document.querySelectorAll('[data-bas-parallax]'));
    if (par.length && !reduce) {
      var ticking = false;
      var apply = function () {
        var vh = window.innerHeight;
        par.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          var shift = Math.max(-18, Math.min(18, progress * -26));
          el.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
        });
        ticking = false;
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      apply();
    }

    if (!reduce) {
      [].slice.call(document.querySelectorAll('[data-bas-tilt]')).forEach(function (el) {
        var raf = null;
        function reset(){ el.style.transform = ''; }
        el.addEventListener('mousemove', function (ev) {
          var rect = el.getBoundingClientRect();
          var px = (ev.clientX - rect.left) / rect.width;
          var py = (ev.clientY - rect.top) / rect.height;
          var rx = (0.5 - py) * 7;
          var ry = (px - 0.5) * 9;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function(){
            el.style.transform = 'perspective(1000px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translate3d(0,-4px,0)';
          });
        });
        el.addEventListener('mouseleave', function () {
          if (raf) cancelAnimationFrame(raf);
          reset();
        });
      });
    }

    /* BASILISK TESTIMONIAL CAROUSEL HARDENING */
    document.querySelectorAll('[data-bas-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.bas-carousel__track');
      var viewport = carousel.querySelector('.bas-carousel__viewport');
      var cards = [].slice.call(carousel.querySelectorAll('.bas-test'));
      var prev = carousel.querySelector('.bas-carousel__nav--prev');
      var next = carousel.querySelector('.bas-carousel__nav--next');
      if (!track || !viewport || cards.length < 2) return;
      var index = 0;
      function visibleCount(){ return window.innerWidth <= 749 ? 1 : (window.innerWidth <= 989 ? 1 : 2); }
      function maxIndex(){ return Math.max(0, cards.length - visibleCount()); }
      function update(){
        index = Math.max(0, Math.min(index, maxIndex()));
        var card = cards[index];
        var offset = card ? card.offsetLeft : 0;
        track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
        cards.forEach(function(cardEl, i){ cardEl.classList.toggle('is-active', i >= index && i < index + visibleCount()); });
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex();
      }
      function go(step){ index += step; update(); }
      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(-1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(1); });
      var startX = null;
      viewport.addEventListener('touchstart', function(e){ startX = e.touches && e.touches[0] ? e.touches[0].clientX : null; }, { passive:true });
      viewport.addEventListener('touchend', function(e){
        if (startX == null || !(e.changedTouches && e.changedTouches[0])) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 36) go(dx < 0 ? 1 : -1);
        startX = null;
      }, { passive:true });
      window.addEventListener('resize', update, { passive:true });
      update();
    });

    /* BASILISK HERO AUTOPLAY RECOVERY */
    document.querySelectorAll('.bas-home-autovideo__video').forEach(function(video){
      function tryPlay(){
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('muted','');
        video.setAttribute('playsinline','');
        video.setAttribute('webkit-playsinline','');
        var p = video.play();
        if (p && typeof p.catch === 'function') { p.catch(function(){}); }
      }
      ['loadedmetadata','canplay','canplaythrough'].forEach(function(evt){ video.addEventListener(evt, tryPlay, { passive:true }); });
      document.addEventListener('visibilitychange', function(){ if (!document.hidden) tryPlay(); }, { passive:true });
      window.addEventListener('pageshow', tryPlay, { passive:true });
      tryPlay();
    });

    document.querySelectorAll('[data-bas-modes-switch]').forEach(function (switcher) {
      var buttons = [].slice.call(switcher.querySelectorAll('.bas-switch'));
      var rootPanel = switcher.closest('.bas-mode-showcase') || document;
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-target');
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          rootPanel.querySelectorAll('[data-mode-panel]').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-mode-panel') === target);
          });
        });
      });
    });

    document.querySelectorAll('[data-bas-mode-strip]').forEach(function (strip) {
      var thumbs = [].slice.call(strip.querySelectorAll('.bas-mode-thumb'));
      var kind = strip.getAttribute('data-mode-kind');
      var scope = strip.closest('[data-mode-panel]') || document;
      var img = scope.querySelector('#bas-mode-image-' + kind);
      var title = scope.querySelector('#bas-mode-title-' + kind);
      var copy = scope.querySelector('#bas-mode-copy-' + kind);
      if (!img || !title || !copy) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
          img.src = thumb.getAttribute('data-image') || img.src;
          img.alt = thumb.getAttribute('data-alt') || thumb.getAttribute('data-title') || '';
          title.textContent = thumb.getAttribute('data-title') || '';
          copy.textContent = thumb.getAttribute('data-copy') || '';
        });
      });
    });

  });
})();


/* BASILISK MOBILE MODES BUTTON RECOVERY */
(function(){
  document.querySelectorAll('[data-bas-modes-switch]').forEach(function (switcher) {
    var buttons = [].slice.call(switcher.querySelectorAll('.bas-switch'));
    var rootPanel = switcher.closest('.bas-mode-showcase') || document;
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var target = btn.getAttribute('data-target');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        rootPanel.querySelectorAll('[data-mode-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-mode-panel') === target);
        });
      });
    });
  });
})();


/* BASILISK STOREWIDE REVEAL SYSTEM */
(function(){
  var targets = document.querySelectorAll('.bas-card, .bas-frame, .bas-step, .bas-kpi, .bas-cta-panel, .bas-home-split__copy > *, .bas-home-proof__media > *, .bas-test-head, .bas-mode-showcase__head');
  targets.forEach(function(el){ el.setAttribute('data-bas-reveal',''); });
  if (!('IntersectionObserver' in window)) { targets.forEach(function(el){ el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if (entry.isIntersecting) entry.target.classList.add('is-in'); }); }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  targets.forEach(function(el){ io.observe(el); });
})();
